import React from 'react'
import { uploadDispatch } from 'client/utils/api-routes-orders'
import { DcButton, DcInput, PixelFactoryContext } from 'pixel-base'
import { AjaxResponse } from 'rxjs-compat'
import styled from 'styled-components'

import { IPixelFactory } from '../../../../../decl.d'

interface Data {
  attachment: File | null
}

interface UploadResponse {
  data?: boolean
  error?: string
}
interface IProps {
  dispatchID: string
  handleClose: (data?: string) => void
}

const UploadDispatch = (props: IProps) => {
  const { dispatchID, handleClose } = props
  const { showPageLoader, hidePageLoader, showSuccess, showFailure } =
    React.useContext<IPixelFactory>(PixelFactoryContext)
  const [data, setData] = React.useState<Data>({
    attachment: null,
  })
  const [error] = React.useState({
    error: '',
    field: '',
  })

  const uploadDispatchAttachment = (e) => {
    e.preventDefault()
    if (error.field === 'attachment') {
      return
    }
    showPageLoader()
    uploadDispatch(data, dispatchID).subscribe(
      (res: AjaxResponse<UploadResponse>) => {
        hidePageLoader()
        if (res.response.data) {
          showSuccess('Dispatch uploaded successfully')
          handleClose('success')
        } else {
          showFailure(res.response.error)
        }
      },
    )
  }

  return (
    <>
      <form onSubmit={uploadDispatchAttachment}>
        <FormGroup>
          <DcInput
            isShowError={
              error.field === 'attachment' && error.error !== '' ? true : false
            }
            errorMessage={
              error.field === 'attachment' && error.error !== ''
                ? error.error
                : null
            }
            type={'file'}
            name={'Select File'}
            placeholder={'Select File'}
            required
            onChange={(e) => {
              setData({
                ...data,
                attachment: e.target.files[0],
              })
            }}
          />
          <Handles>
            <DcButton
              size="sm"
              variant="outline-secondary"
              onClick={() => {
                handleClose()
              }}
            >
              Cancel
            </DcButton>
            <DcButton
              type={'submit'}
              size="sm"
              disabled={data.attachment === null}
            >
              Upload
            </DcButton>
          </Handles>
        </FormGroup>
      </form>
    </>
  )
}

export default UploadDispatch
const FormGroup = styled.div<{ flexEnd?: boolean }>`
  display: inline-flex;
  flex-direction: column;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: flex-end;
  align-content: flex-end;
  width: 100%;
  flex-grow: 1;
  gap: 10px;
  .full-width {
    flex-grow: 1;
  }
`
const Handles = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
`
